import React from 'react';

import type { ProductDetailsScreenProps } from '../../navigation/AppNavigation.props';
import { ProductDetails } from './components';

export const ProductDetailsScreen = ({
  navigation,
  route,
}: ProductDetailsScreenProps) => {
  const {
    restaurantSlug,
    productSlug,
    ingredientIds,
    name: encodedName,
  } = route.params;

  const name = encodedName ? decodeURIComponent(encodedName) : null;
  const decodedIngredientIds = ingredientIds
    ? decodeURIComponent(ingredientIds)
    : null;

  const handleAddLineItemToCart = React.useCallback(() => {
    navigation.replace('Bag');
  }, [navigation]);

  return (
    <ProductDetails
      restaurantSlug={restaurantSlug}
      productSlug={productSlug}
      ingredientIds={decodedIngredientIds?.split(',')}
      onAddLineItemToCart={handleAddLineItemToCart}
      name={name}
    />
  );
};
